import { enUS, nl } from "date-fns/locale";
import type { Locale } from "date-fns";

import type { AppLocale } from "@/lib/locale/resolve-effective-locale";

const DATE_FNS_LOCALES: Record<AppLocale, Locale> = {
  nl,
  en: enUS,
};

export function getDateFnsLocale(locale: AppLocale): Locale {
  return DATE_FNS_LOCALES[locale];
}
